import { render, staticRenderFns } from "./ReferralCommissionTable.vue?vue&type=template&id=5a3d31f1&"
import script from "./ReferralCommissionTable.vue?vue&type=script&lang=ts&"
export * from "./ReferralCommissionTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports